module.exports = __webpack_public_path__ + "img/TSY_04_03.e9acb150.png";